import { t } from '@ping/helpers';
import { ButtonA11Y, Modal, Text } from '@ping/uikit';

import style from './style.module.scss';

interface ICorePassFinalApprovalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
}

export const CorePassFinalApproval = ({ isOpen, onClose, onAccept }: ICorePassFinalApprovalProps) => (
  <Modal.Root isOpen={isOpen} onOpenChange={open => !open && onClose()}>
    <Modal.Portal className={style['portal']} divide entrance='center'>
      <Modal.Header className={style['header']}>
        <Modal.Title>{t('Approve this withdrawal')}</Modal.Title>
      </Modal.Header>
      <Modal.Content className={style['content']}>
        <Text body='regular'>{t('After you accept, this withdrawal request is sent to CorePass.')}</Text>
      </Modal.Content>
      <Modal.Actions className={style['actions']}>
        <ButtonA11Y secondary className={style['button']} onPress={onClose}>
          {t('Cancel')}
        </ButtonA11Y>
        <ButtonA11Y primary className={style['button']} onPress={onAccept}>
          {t('I accept')}
        </ButtonA11Y>
      </Modal.Actions>
    </Modal.Portal>
  </Modal.Root>
);
